import { debugLog } from './utils.js';

export const flutterMessenger = {
  send(eventName, message = '') {
    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler(eventName, message);
    } else {
      console.error('flutter_inappwebview is empty');
    }
  },

  registerCallbacks() {
    debugLog('registerCallbacks');
    window.postMessageFromFlutter = function (event, message) {
      if (flutterMessenger.callbacks.hasOwnProperty(event)) {
        debugLog(`call callback: event:${event}, message: ${message}`);
        flutterMessenger.callbacks[event](message);
      } else {
        alert('callback not found');
      }
    }; 
  },

  callbacks: {
    msg(message) {
      document.getElementById('msg').innerText = 'Flutter says: ' + message;
    },
  },
};

if (!window.flutter_inappwebview) {
  window.flutter_inappwebview = {
    callHandler(eventName, message) {
      console.error('Flutter is not found!');
      debugLog(`eventName: ${eventName}, message: ${message}`);
    },
  };
}
